import { elevateSuperRush } from "../../utils/constants/signalmanConstants";

class ElevateSuperRushTest {
    constructor() {
      this.flag = elevateSuperRush;
      this.fireMetrics();
      this.dataLayerPush();
    }
  
    fireMetrics() {
      return CustomInk.Metrics.fireEvent(
        'testing',
        '2024 07 16 elevate turn time',
        `2024 07 16 elevate turn time ${this.flag}`
      );
    }

    dataLayerPush() {
      return window.dataLayer.push({
        event: 'ab_test_group',
        ab_test_name: '2024 07 16 elevating turn times in catalog',
        ab_test_location: 'plp catalog',
        ab_test_group: this.flag
      });
    }
  }
  
ProductCatalog.ElevateSuperRushTest =
  new ElevateSuperRushTest();
  